import React, { useState, useImperativeHandle, useEffect, forwardRef, useRef } from 'react'
import Api from '../../../../_helpers/Api'
import { trans } from '../../../../_providers/Translation'

//images
import docIcon from '../../../../assets/img/icons/document.png'
import closeIcon from '../../../../assets/img/icons/close.png'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"
import loader from '../../../../assets/img/loader.svg'
import deleteIcon from "@/assets/img/reservations/icons/delete.svg"
import AppliancesCategoriesPricing from '../../../partials/AppliancesCategoriesPricing'
import { Checkbox, FormControlLabel, Tab, Tabs } from '@mui/material'
import Help from '@/components/partials/Help'

function Settings(props, ref) {

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        data: {},
        loading: false,
        id: null,
        priceTypes: [],
        invoicePeriods: [],
        appliancesCategoriesPrices: []
    })

    const [activeTab, setActiveTab] = useState('settings')
    const [validations, setValidations] = useState(null)
    const [statusPriceRules, setStatusPriceRules] = useState([])
    const [initialStatuses, setInitialStatuses] = useState([])
    const [finalStatuses, setFinalStatuses] = useState([])

    useImperativeHandle(ref, () => ({
        open: id => {
            handleShow(id)
        },
        hide: () => {
            handleHide()
        }
    }))

    useEffect(() => {
        if (
            selectedPriceIsCategory() &&
            popup.appliancesCategoriesPrices.length === 0
        ) {
            Api.get('partners/relationships/settings/categories/prices?related_partner_id=' + popup.id)
                .then(res => {
                    setPopup(prev => ({
                        ...prev,
                        appliancesCategoriesPrices: res.data
                    }))
                })
        }
    }, [popup.data.price_type_id, popup.priceTypes])

    const handleShow = (id) => {

        loadData(id)
        loadPriceTypes()
        loadInvoicingPeriods()
        loadStatuses()

        setPopup(prev => ({
            ...prev,
            overlay: true,
            id: id
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const loadData = id => {
        Api.get('partners/relationships/show?related_partner_id=' + id)
            .then(res => {
                setPopup(prev => ({
                    ...prev,
                    data: res.data
                }))

                setStatusPriceRules(Array.isArray(res.data.pricing) ? res.data.pricing : [])
            })
    }

    const loadStatuses = () => {
        Api.get('reservations/initial-and-final-statuses')
            .then(res => {
                setInitialStatuses(Array.isArray(res.data?.initial) ? res.data.initial : [])
                setFinalStatuses(Array.isArray(res.data?.final) ? res.data.final : [])
            })
    }

    const loadPriceTypes = () => {
        Api.get('partners/relationships/price-types')
            .then(res => {
                setPopup(prev => ({
                    ...prev,
                    priceTypes: res.data
                }))
            })
    }

    const loadInvoicingPeriods = () => {
        Api.get('partners/relationships/invoicing-periods')
            .then(res => {
                setPopup(prev => ({
                    ...prev,
                    invoicePeriods: res.data
                }))
            })
    }

    const handleHide = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            data: {},
            appliancesCategoriesPrices: [],
            modal: false,
            loading: false,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false
            }))
        }, 50)
    }

    const handleSave = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)

        let url = 'partners/relationships/settings/edit'

        let data = new FormData(e.target)
        data.append('related_partner_id', popup.id)

        // Add checkbox values explicitly as FormData may not capture unchecked checkboxes
        data.append('allow_reassign', popup.data.allow_reassign ? 1 : 0)
        data.append('allow_parts_profit', popup.data.allow_parts_profit ? 1 : 0)
        data.append('can_see_parts_prices', popup.data.can_see_parts_prices ? 1 : 0)
        data.append('can_see_labour_price', popup.data.can_see_labour_price ? 1 : 0)
        data.append('can_see_parts_batch_numbers', popup.data.can_see_parts_batch_numbers ? 1 : 0)

        // Add other fields that might be conditionally hidden
        if (popup.data.max_reservations) {
            data.set('max_reservations', popup.data.max_reservations)
        }
        if (popup.data.price_type_id) {
            data.set('price_type_id', popup.data.price_type_id)
        }
        if (popup.data.price) {
            data.set('price', popup.data.price)
        }
        if (popup.data.parts_profit_method) {
            data.set('parts_profit_method', popup.data.parts_profit_method)
        }
        if (popup.data.parts_profit_value) {
            data.set('parts_profit_value', popup.data.parts_profit_value)
        }
        if (popup.data.invoice_period_id) {
            data.set('invoice_period_id', popup.data.invoice_period_id)
        }
        if (popup.data.payment_period) {
            data.set('payment_period', popup.data.payment_period)
        }

        Api.post(url, data)
            .then(res => {

                if (res.data.success) {
                    props.handleRefresh()
                }

                handleHide(e)

                document.getElementById("form").reset()

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                }

            })
    }

    const handleInputChange = e => {
        let name = e.target.name
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }

    const handleCheckboxChange = e => {
        let name = e.target.name

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: !prev.data[name]
            }
        }))
    }

    const getSelectedPrice = () => {
        if (popup.data && popup.data.price_type_id) {
            let type = popup.priceTypes.filter(t => Number(t.id) === Number(popup.data.price_type_id))[0]

            if (type) {
                return type
            }
        }

        return null
    }

    const selectedPriceIsCategory = () => {
        let type = getSelectedPrice()

        if (type) {
            return type.is_category
        }

        return null
    }

    const selectedPriceIsStatus = () => {
        let type = getSelectedPrice()

        if (type) {
            return type.is_status
        }

        return null
    }

    const selectedPriceIsFixed = () => {
        let type = getSelectedPrice()

        if (type) {
            return type.is_fixed
        }

        return null
    }

    const selectedPriceIsPercent = () => {
        if (!(popup.data && popup.data.price_type_id & popup.data.price_type_id)) {
            return true
        }

        let type = getSelectedPrice()

        if (type) {
            return type.is_percent
        }

        return null
    }

    const addStatusPriceRule = () => {
        setStatusPriceRules(prev => [...prev, { type: '', status_id: '', price: '' }])
    }

    const removeStatusPriceRule = index => {
        setStatusPriceRules(prev => prev.filter((_, i) => i !== index))
    }

    const handleStatusPriceRuleChange = (index, field, value) => {
        setStatusPriceRules(prev => prev.map((rule, i) =>
            i === index
                ? { ...rule, [field]: value, ...(field === 'type' ? { status_id: '' } : {}) }
                : rule
        ))
    }

    const handleTabChange = (tab) => {
        setActiveTab(tab)
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form id="form" className={`${popup.modal ? 'show' : ''} partner-settings-popup popup-primary large`} onSubmit={handleSave}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {trans('headings.companySettings')}
                        </h2>
                        <p>{trans('subheadings.companySettings')}</p>
                    </div>
                    <span className='close' onClick={handleHide}>

                    </span>
                </div>
                <Tabs
                    value={activeTab}
                    onChange={(e, newValue) => handleTabChange(newValue)}
                    variant="scrollable"
                    scrollButtons="auto"
                    indicatorColor="primary"
                    textColor="primary"
                    aria-label="scrollable force tabs"
                >
                    <Tab value="settings" label={trans('tabs.settings')} disableRipple />
                    <Tab value="access" label={trans('tabs.access')} disableRipple />
                </Tabs>

                <div style={{ display: activeTab === 'settings' ? 'block' : 'none' }}>
                    <div className='row'>
                        <div className="col">
                            <label>
                                {trans('labels.invoicePeriod')}
                            </label>
                            <select
                                name="invoice_period_id"
                                value={popup.data && popup.data.invoice_period_id ? popup.data.invoice_period_id : ''}
                                onChange={handleInputChange}
                            >
                                {popup.invoicePeriods.map(p =>
                                    <option
                                        key={'ip-' + p.id}
                                        value={p.id}
                                    >
                                        {p.translation ? p.translation.name : p.name}
                                    </option>
                                )}
                            </select>
                        </div>
                        <div className="col">
                            <label>
                                {trans('labels.timeForPaing')}
                            </label>
                            <input
                                type="number"
                                min="0"
                                step="1"
                                name="payment_period"
                                value={popup.data && popup.data.payment_period ? popup.data.payment_period : ''}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        <div className='col'>
                            <b>{trans('tabs.reservations')}</b>
                            <div className='row'>
                                <div className='col'>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="allow_reassign"
                                                value="1"
                                                checked={popup.data && Number(popup.data.allow_reassign) === 1 ? true : false}
                                                onChange={handleCheckboxChange}
                                                size='small'
                                            />
                                        }
                                        label={trans('labels.canSeePartsPrices')}
                                    />
                                </div>
                            </div>

                            {/* {popup.data && Number(popup.data.allow_reassign) === 1 && ( */}
                                <>
                                    <div className="row">
                                        <div className="col">
                                            <label>
                                                {trans('labels.maxReservations')}
                                            </label>
                                            <input
                                                type="number"
                                                min="0"
                                                step="1"
                                                name="max_reservations"
                                                value={popup.data && popup.data.max_reservations ? popup.data.max_reservations : ''}
                                                onChange={handleInputChange}
                                            />

                                        </div>
                                        <div className="col">
                                            <div className='row'>
                                                <div className='col'>
                                                    <label>
                                                        {trans('labels.pricingMethod')}
                                                    </label>
                                                    <select
                                                        name="price_type_id"
                                                        value={popup.data && popup.data.price_type_id ? popup.data.price_type_id : popup.priceTypes[0]?.id || ''}
                                                        onChange={handleInputChange}
                                                    >
                                                        {popup.priceTypes.map(t =>
                                                            <option key={'pt-' + t.id} value={t.id}>
                                                                {t.translation && t.translation.name}
                                                            </option>
                                                        )}
                                                    </select>
                                                </div>
                                                {selectedPriceIsPercent() || selectedPriceIsFixed() ?
                                                    <div
                                                        className='col'
                                                        style={{
                                                            maxWidth: "120px"
                                                        }}
                                                    >
                                                        {selectedPriceIsPercent() && (
                                                            <>
                                                                <label>
                                                                    {trans('labels.percentage')} <Help>{trans('labels.companyTax')}</Help>
                                                                </label>
                                                                <div className="input-with-unit">
                                                                    <input
                                                                        type="number"
                                                                        step="0.01"
                                                                        min="0"
                                                                        max="100"
                                                                        name="price"
                                                                        value={popup.data ? popup.data.price : ''}
                                                                        className={validations && validations.price ? 'validate' : ''}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                    <span className="unit">%</span>
                                                                </div>
                                                            </>
                                                        )}
                                                        {selectedPriceIsFixed() && (
                                                            <>
                                                                <label>
                                                                    {trans('labels.amountValue')} <Help>{trans('labels.companyTaxPrice')}</Help>
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    step="0.01"
                                                                    min="0"
                                                                    name="price"
                                                                    value={popup.data ? popup.data.price : ''}
                                                                    className={validations && validations.price ? 'validate' : ''}
                                                                    onChange={handleInputChange}
                                                                />
                                                            </>
                                                        )}

                                                    </div>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {selectedPriceIsCategory() && (
                                        <div className="form-group" style={{ width: '100%' }}>
                                            <label>
                                                {trans('labels.categoryPricing')}
                                            </label>
                                            <div className="scrollable" style={{ maxHeight: '300px', padding: '0 10px 0 0' }}>
                                                <AppliancesCategoriesPricing
                                                    prices={popup.appliancesCategoriesPrices}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {selectedPriceIsStatus() && <>
                                        <div className="row">
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col">
                                                        {statusPriceRules.map((rule, index) => (
                                                            <div key={index} className="row" style={{ alignItems: 'flex-end', marginBottom: '8px' }}>
                                                                <input type="hidden" name={`status_price_rules[${index}][id]`} value={rule.id || ''} />
                                                                <div className="col">
                                                                    <label>{trans('labels.type')}</label>
                                                                    <select
                                                                        name={`status_price_rules[${index}][type]`}
                                                                        value={rule.type}
                                                                        onChange={e => handleStatusPriceRuleChange(index, 'type', e.target.value)}
                                                                    >
                                                                        <option value="" disabled>{trans('labels.choose')}</option>
                                                                        <option value="initial">{trans('labels.initialStatus')}</option>
                                                                        <option value="final">{trans('labels.finalStatus')}</option>
                                                                    </select>
                                                                </div>
                                                                <div className="col">
                                                                    <label>{trans('labels.status')}</label>
                                                                    <select
                                                                        name={`status_price_rules[${index}][status_id]`}
                                                                        value={rule.status_id}
                                                                        onChange={e => handleStatusPriceRuleChange(index, 'status_id', e.target.value)}
                                                                    >
                                                                        <option value=""></option>
                                                                        {(rule.type === 'initial' ? initialStatuses : rule.type === 'final' ? finalStatuses : []).map(s => (
                                                                            <option key={s.id} value={s.id}>{s.translation?.name || s.name}</option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                <div
                                                                    className="col"
                                                                    style={{
                                                                        maxWidth: "200px",
                                                                        flexShrink: 0
                                                                    }}
                                                                >
                                                                    <label>{trans('labels.price')}</label>
                                                                    <div className="input-with-unit">
                                                                        <input
                                                                            type="number"
                                                                            step="0.01"
                                                                            min="0"
                                                                            name={`status_price_rules[${index}][price]`}
                                                                            value={rule.price}
                                                                            onChange={e => handleStatusPriceRuleChange(index, 'price', e.target.value)}
                                                                        />
                                                                        <span className='unit'>
                                                                            EUR
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div style={{ flexShrink: 0, paddingBottom: '2px' }}>
                                                                    <button
                                                                        type="button" className="button button-remove button-small"
                                                                        onClick={() => removeStatusPriceRule(index)}
                                                                        style={{
                                                                            width: "40px",
                                                                            height: "40px",
                                                                            padding: 0,
                                                                            minWidth: "initial",
                                                                            flexShrink: 0,
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={deleteIcon}
                                                                            alt="delete"
                                                                        />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="button button-add button-small"
                                                    style={{
                                                        width: "fit-content",
                                                    }}
                                                    onClick={addStatusPriceRule}
                                                >
                                                    {trans('buttons.add')}
                                                </button>
                                            </div>
                                        </div>
                                    </>}
                                </>
                            {/* )} */}
                        </div>
                    </div>
                    <hr />
                    {/* Печалба от части section */}
                    <div className="row">
                        <div className='col'>
                            <b>{trans('labels.profitFromParts')}</b>
                            <div className='row'>
                                <div className='col'>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="allow_parts_profit"
                                                value="1"
                                                checked={popup.data && Number(popup.data.allow_parts_profit) === 1 ? true : false}
                                                onChange={handleCheckboxChange}
                                                size='small'
                                            />
                                        }
                                        label={trans('labels.allowPartsProfit')}
                                    />
                                </div>
                            </div>

                            {popup.data && Number(popup.data.allow_parts_profit) === 1 && (
                                <div className="row">
                                    <div className="col">
                                        <label>
                                            {trans('labels.partsMethodOfProfit')}
                                        </label>
                                        <select
                                            name="parts_profit_method"
                                            value={popup.data && popup.data.parts_profit_method ? popup.data.parts_profit_method : 'percent'}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">{trans('labels.withoutLabel')}</option>
                                            <option value="FIXED">
                                                {trans('externalEmployee.partsMarkupFixed')}
                                            </option>
                                            <option value="PERCENTAGE">
                                                {trans('externalEmployee.partsMarkupPercent')}
                                            </option>
                                        </select>
                                    </div>
                                    {(popup.data.parts_profit_method || "").length ?
                                        <div
                                            className='col'
                                            style={{
                                                maxWidth: "120px"
                                            }}
                                        >
                                            {popup.data.parts_profit_method === 'PERCENTAGE' ?
                                                <>
                                                    <label>
                                                        {trans('labels.percentage')} <Help>{trans('externalEmployee.partsMarkupValuePercent')}</Help>
                                                    </label>
                                                    <div className="input-with-unit">
                                                        <input
                                                            type="number"
                                                            step="0.01"
                                                            min="0"
                                                            max="100"
                                                            name="parts_profit_value"
                                                            value={popup.data && popup.data.parts_profit_value ? popup.data.parts_profit_value : '20'}
                                                            className={validations && validations.parts_profit_value ? 'validate' : ''}
                                                            onChange={handleInputChange}
                                                        />
                                                        <span className="unit">%</span>
                                                    </div>
                                                </>
                                                :
                                                <></>
                                            }

                                            {popup.data.parts_profit_method === 'FIXED' ?
                                                <>
                                                    <label>
                                                        {trans('labels.amountValue')} <Help>{trans('externalEmployee.partsMarkupValueFixed')}</Help>
                                                    </label>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        min="0"
                                                        max="100"
                                                        name="parts_profit_value"
                                                        value={popup.data && popup.data.parts_profit_value ? popup.data.parts_profit_value : '20'}
                                                        className={validations && validations.parts_profit_value ? 'validate' : ''}
                                                        onChange={handleInputChange}
                                                    />
                                                </>
                                                :
                                                <>
                                                </>
                                            }
                                        </div>
                                        :
                                        <>
                                        </>
                                    }
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div style={{ display: activeTab === 'access' ? 'block' : 'none' }}>
                    <div className="tab-content">
                        <div className="section">
                            <label>{trans('labels.optionsVisibleToPartners')}</label>
                            <div className='checkbox-list'>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="can_see_parts_prices"
                                            value="1"
                                            checked={popup.data && Number(popup.data.can_see_parts_prices) === 1 ? true : false}
                                            onChange={handleCheckboxChange}
                                            size='small'
                                        />
                                    }
                                    label={trans('labels.canSeePartsPrices')}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="can_see_labour_price"
                                            value="1"
                                            checked={popup.data && Number(popup.data.can_see_labour_price) === 1 ? true : false}
                                            onChange={handleCheckboxChange}
                                            size='small'
                                        />
                                    }
                                    label={trans('labels.canSeeLaborPrice')}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="can_see_parts_batch_numbers"
                                            value="1"
                                            checked={popup.data && Number(popup.data.can_see_parts_batch_numbers) === 1 ? true : false}
                                            onChange={handleCheckboxChange}
                                            size='small'
                                        />
                                    }
                                    label={trans('labels.canSeePartsBatchNumbers')}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer align-right">
                    {popup.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleHide}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    }
                </div>
            </form >
        </div >
    )
}

export default forwardRef(Settings)